import { Component, Inject, effect } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PaymentService } from '../../../features/payment/payment.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-payment-summary-popup',
    templateUrl: './payment-summary-popup.component.html',
    styleUrl: './payment-summary-popup.component.sass',
    standalone: false
})

export class PaymentSummaryPopupComponent {

  purchaseInfo = false;
  termsConditions = false;
  previousRoute = '';
  asstAmount = {};
  adtAmount = {};
  clipAmount = {};
  clipAdtAmount = {};
  docAmount = {};
  showPopup = false;

  constructor(private dialogRef: MatDialogRef<PaymentSummaryPopupComponent>, public router: Router,
              private paymentService: PaymentService, @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService) {

    effect(() => {
      this.previousRoute = this.paymentService.routeInfo;
      this.asstAmount = this.paymentService.asstAmount;
      this.adtAmount = this.paymentService.adtAmount;
      this.docAmount = this.paymentService.docAmount;
      this.clipAmount = this.paymentService.clipAmount;
      this.clipAdtAmount = this.paymentService.clipAdtAmount;
      const isNonEmpty = (v: any) => v && typeof v === 'object' && Object.keys(v).length > 0;

      let source: any = null;
      if(this.previousRoute === 'assistance' && isNonEmpty(this.asstAmount)) {
        source = this.asstAmount;
      } else if(isNonEmpty(this.docAmount)) {
        source = this.docAmount;
      } else if(isNonEmpty(this.adtAmount)) {
        source = this.adtAmount;
      } else if(isNonEmpty(this.clipAmount)) {
        source = this.clipAmount;
      } else if(isNonEmpty(this.clipAdtAmount)) {
        source = this.clipAdtAmount;
      }

      if(source) {
        this.data = source;
        this.showPopup = true;
      } else {
        this.showPopup = false;
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
    this.showPopup = false;
  }

  confirmPay() {
    this.closeDialog();
    this.router.navigateByUrl('payment');
  }

  cancelPay() {
    this.purchaseInfo = false;
    this.termsConditions = false;
    this.closeDialog();
  }

  get tcDoc() : string {
    return environment.bucket_public_url + `Terms_and_Conditions_ASOS_${this.translate.currentLang.toUpperCase()}_June_2026.pdf`;
  }

}